export enum Turno{
    MANHA
}
